'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MiniCard = require('./MiniCard.css');

var _MiniCard2 = _interopRequireDefault(_MiniCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var miniCardClick = function miniCardClick(linkProps) {
  if (linkProps.trackEvent) {
    linkProps.trackEvent('score_card_click', linkProps.url);
  }
  window.location = linkProps.url;
};

var MiniCard = function MiniCard(props) {
  if (props.linkProps) {
    return _react2.default.createElement(
      'div',
      { style: props.imageUrl && { backgroundImage: 'url(' + props.imageUrl + ')' }, role: 'button', tabIndex: '0', onClick: function onClick() {
          return miniCardClick(props.linkProps);
        }, className: 'jsx-' + _MiniCard2.default.__scopedHash + ' ' + 'miniCard link'
      },
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _MiniCard2.default.__scopedHash + ' ' + 'captionBox'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _MiniCard2.default.__scopedHash + ' ' + 'caption'
          },
          props.caption
        )
      ),
      _react2.default.createElement(_style2.default, {
        styleId: _MiniCard2.default.__scopedHash,
        css: _MiniCard2.default.__scoped
      })
    );
  }

  return _react2.default.createElement(
    'div',
    { style: props.imageUrl && { backgroundImage: 'url(' + props.imageUrl + ')' }, className: 'jsx-' + _MiniCard2.default.__scopedHash + ' ' + 'miniCard'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-' + _MiniCard2.default.__scopedHash + ' ' + 'captionBox'
      },
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _MiniCard2.default.__scopedHash + ' ' + 'caption'
        },
        props.caption
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: _MiniCard2.default.__scopedHash,
      css: _MiniCard2.default.__scoped
    })
  );
};

MiniCard.propTypes = {
  caption: _propTypes2.default.string.isRequired,
  imageUrl: _propTypes2.default.string,
  linkProps: _propTypes2.default.shape({
    url: _propTypes2.default.string.isRequired,
    trackEvent: _propTypes2.default.func
  })
};

MiniCard.defaultProps = {
  imageUrl: null,
  linkProps: null
};

exports.default = MiniCard;